import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { PHP_API } from "../../../utils/Common";
import Post from "../../../utils/Post";
import CantidadSiembraSemanal from "./CantidadSiembraSemanal";
import MyLoader from "../../sharecomponents/MyLoader";
import './estilos/planSiembraEstilo.css';
import { getWeekNumber } from "../../../utils/Common";
import { generarExcel } from "../../sharecomponents/ExcelUtilities";
import EjecucionSiembraPDF from "../../templates/EjecucionSiembraPDF";
import InputSemanaEjecucion from "./PlanSimebraComponents/InputSemanaEjecucion";
import Verifiers from "../../../utils/Verifiers";
import HistorialEjecucionesSiembra from "./PlanSimebraComponents/HistorialEjecucionesSiembra";
import EditorRendimientoSiembra from "./PlanSimebraComponents/EditorRendimientoSiembra";

const initSemana = Object.freeze({
   semana: "",
   florid: "0",
});

const EjecucionSiembra = (props) => {
   const week = getWeekNumber();
   const [loader, updateLoader] = useState(false);
   const [planes, setPlanes] = useState([]);
   const [semanas, setSemanas] = useState([])
   const [tipos, settipos] = useState({ flores: [], variedades: [], colores: [] });
   const [flores, setFlores] = useState([]);
   const [args, setargs] = useState({ semana: "", flor: "", variedad: '', color: '', florid: "" });
   const dias = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'];
   const [totales, settotales] = useState({ charolas: 0, plantas: 0, ejecutadocharolas: 0, ejecutadoplantas: 0, plancharolas: 0, planplantas: 0 });
   const [editorRendimiento, seteditorRendimiento] = useState(false);
   const totales_keys = [
      { key: '', name: 'PLAN DE SIEMBRA', color: "text-blue-900 bg-blue-100 border-blue-400" },
      { key: 'plan', name: 'PLANEADO', color: "text-red-900 bg-red-100 border-red-400" },
      { key: 'ejecutado', name: 'EJECUTADO', color: "text-green-900 bg-green-100 border-green-400" }
   ];
   const [screen, setscreen] = useState({ width: window.innerWidth, height: window.innerHeight });
   var counter = 0;

   const [pdf, setpdf] = useState(false);
   const [showHistory, setShowHistory] = useState(false);

   useEffect(() => {
      if (counter > 0) return;
      counter++;
      initialData();
      let semana = (`${week[0] > 9 ? week[0] : "0" + week[0]}`).substring(2, 4) + (week[1] > 9 ? week[1] : "0" + week[1]);
      let arg = { ...args, semana };
      getPlanSiembra(arg, undefined);
      Verifiers.onScreenResize(setscreen);
   }, []);

   const ajustarArgs = (e) => {
      let ar = { ...args };
      ar[e.target.name] = e.target.value;
      setargs(ar);
      getPlanSiembra(ar);
   }


   const initialData = () => {
      updateLoader(true);
      //semanas disponiblles con planes de siembra definidos 
      Post("api/genPlanesData").then((r) => {
         updateLoader(false);
         setSemanas(r.data.semanas);
         settipos({ flores: r.data.flores, variedades: r.data.variedades, colores: r.data.colores });
      })
         .catch((e) => console.log(e));
   }

   /**
    * Obtiene el plan de siembra para una semana especifica
    * @param {object} ar carga util que se enviará al servidor para obtener los detalles del plan de siembra de una semana determinada
    * @returns null
    */
   const getPlanSiembra = async (ar) => {
      if (!ar) ar = { ...args, semana: "2419" };
      if (!ar.semana) {
         setPlanes([]);
         return;
      }
      let resp = await Post("api/getPlanEjecucionSemanal", ar, 'POST', updateLoader);
      if (!resp.estatus) {
         return;
      }
      setPlanes(resp.planes);
      setFlores(resp.flores);
      settotales(resp.totales);
      setargs(ar);

   };

   const actualizarTotales = (cantidad, indice, dia) => {
      let total = 0;
      cantidad = Verifiers.numberParser(cantidad, 0);
      let pl = JSON.parse(JSON.stringify(planes));
      pl[indice][dia + "_plan"] = cantidad;
      pl[indice].total_planeado =
         Verifiers.numberParser(pl[indice].lunes_plan) +
         Verifiers.numberParser(pl[indice].martes_plan) +
         Verifiers.numberParser(pl[indice].miercoles_plan) +
         Verifiers.numberParser(pl[indice].jueves_plan) +
         Verifiers.numberParser(pl[indice].viernes_plan) +
         Verifiers.numberParser(pl[indice].sabado_plan);
      // -- suma de lo planeado
      for (let i = 0; i < planes.length; i++) {
         total += pl[i].total_planeado;
      }
      setPlanes(pl);
   };

   /**
    * @returns {JSX.Element} - Retorna un renglon con la sumatoria de las columnas de la tabla de planes de siembra
    */
   const renglonSumatoriaDeColumnas = () => {
      let diasNombres = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
      let diasNombresLen = diasNombres.length;
      let planesLen = planes.length;
      let rendimientoIndefinido = false;

      let resultados = {
         total_plan: 0,
         total_ejecutado: 0,
         planeado_horas_total: 0,
         charolas: 0,
         plantas: 0,
         horas_plan: 0
      };

      for (let i = 0; i < diasNombresLen; i++) {
         let keyPlan = diasNombres[i] + '_plan';
         let keyPlanHoras = diasNombres[i] + '_plan_horas';
         let keyEjecutado = diasNombres[i] + '_ejecutado';
         resultados[keyPlan] = 0;
         resultados[keyEjecutado] = 0;
         resultados[keyPlanHoras] = 0;
      }

      for (let i = 0; i < planesLen; i++) {
         let plan = planes[i];
         let flor = plan.flor ?? "";
         let rendimiento = plan.unidad_hora && plan.unidad_hora > 0 ? plan.unidad_hora : false;
         try {
            flor = plan.flor.toUpperCase();
         } catch (error) { }

         for (let j = 0; j < diasNombresLen; j++) {
            let keyPlan = diasNombres[j] + '_plan';
            let keyEjecutado = diasNombres[j] + '_ejecutado';
            let keyPlanHoras = diasNombres[j] + '_plan_horas';
            resultados[keyPlan] += Verifiers.numberParser(plan[keyPlan], 0);
            resultados[keyEjecutado] += Verifiers.numberParser(plan[keyEjecutado], 0);

            //El total de horas planeadas por dia se agrega solo si está definido el rendimiento
            if (rendimiento) {
               resultados[keyPlanHoras] += Verifiers.numberParser(plan[keyPlan], 0) / rendimiento;
               resultados.planeado_horas_total += Verifiers.numberParser(plan[keyPlan], 0) / rendimiento;
            }
         }

         resultados.charolas += Verifiers.numberParser(plan.charolas, 0);
         resultados.plantas += Verifiers.numberParser(plan.plantas, 0);
         if (rendimiento) {
            resultados.horas_plan += Math.ceil(plan.total_planeado / rendimiento);
         } else if (!rendimientoIndefinido) {
            rendimientoIndefinido = true;
         }
      }

      for (let i = 0; i < diasNombresLen; i++) {
         let keyPlan = diasNombres[i] + '_plan';
         let keyEjecutado = diasNombres[i] + '_ejecutado';
         resultados.total_plan += resultados[keyPlan];
         resultados.total_ejecutado += resultados[keyEjecutado];
      }

      return (
         <tr className="bg-white dosis text-bold text-m" style={{ position: "sticky", bottom: 0, zIndex: 2 }}>
            <td className="border nowrap text-bold text-m pt-3 bg-light text-center text-red3" colSpan={4}>Totales</td>
            <td className="border text-center nowrap text-s pt-3 bg-light">
               {Math.ceil(resultados.plantas, 0)}
               {divisor()}{Math.ceil(resultados.charolas, 0)}
               {divisor()}<span className={rendimientoIndefinido ? 'text-red3' : ''}>{Math.ceil(resultados.horas_plan, 0)}</span>
            </td>
            <td className='text-center text-bold bw-200 pt-3 bg-light'>
               {Math.ceil(resultados.total_plan)}
               {divisor()}<span className={rendimientoIndefinido ? 'text-red3' : ''}>{Math.ceil(resultados.planeado_horas_total, 0)}</span>
               {divisor()}<span className={rendimientoIndefinido ? 'text-red3' : ''}>{Math.ceil(resultados.planeado_horas_total / 8, 0)}</span>
            </td>
            {
               diasNombres.map((dia, j) => {
                  let keyPlan = dia + '_plan';
                  let keyPlanHoras = dia + '_plan_horas';
                  return (
                     <td className="border text-center text-s pt-3 bg-light" key={'dia sdsect' + j}>

                        <div className='w-100 text-center m-0 p-0'>
                           {Math.ceil(resultados[keyPlan])}
                           {divisor(true)}<span className={rendimientoIndefinido ? 'text-red3' : ''}>{Math.ceil(resultados[keyPlanHoras])}</span>
                           {divisor(true)}<span className={rendimientoIndefinido ? 'text-red3' : ''}>{Math.ceil(resultados[keyPlanHoras] / 8)}</span>
                        </div>

                     </td>
                  )
               })
            }
         </tr >
      )

   }

   /**
    * Determina si un valor recibido es realmente un valor númerico, en caso de serlo lo retorna, en caso contrario retorna el valor por defecto, el cual es cero en caso de no definirse
    * @param {any} number 
    * @param {number} defaultValue valor por defecto en caso de no ser un valor númerico
    * @returns 
    */
   const numberFormat = (number, defaultValue = 0) => {
      try {
         let format = parseFloat(number);
         if (isNaN(format)) return defaultValue;
         return format;
      } catch (error) {
         return defaultValue;
      }
   }

   /**
       * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
       * @param {object} p - un elemento del plan de siembra de la lista alojada en data
       * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
       */
   const diferencia = (p) => {
      if (p.semana_ejecucion && p.fecha_inicio) {
         let inicio = new Date(p.fecha_inicio);
         let ejecucion = new Date(p.fecha_semana_ejecucion);

         let diferencia = ejecucion - inicio;
         let dias = diferencia / (1000 * 60 * 60 * 24);
         let semanas = dias / 7;
         return Math.floor(semanas);
      }
      return 0;
   }

   const divisor = (space = false) => (<span className={`ms-${space ? 3 : 1} me-${space ? 3 : 1} text-900`}>|</span>)

   const descargarExcel = () => {
      if (planes.length === 0) return;
      let dt = [];
      for (let i = 0; i < planes.length; i++) {
         let p = planes[i];
         let rendimiento = p.unidad_hora && p.unidad_hora > 0 ? p.unidad_hora : false;
         let reg = {
            'SEMANA SIEMBRA': p.semana_siembra,
            'TRASPLANTE': p.transplante,
            FLOR: `${p.flor} ${p.variedad} ${p.color}`,
            'PLAN SIEMBRA PLANTAS': Math.ceil(p.plantas),
            'PLAN SIEMBRA CHAROLAS': Math.ceil(p.charolas),
            'TOTAL PLANEADO': (numberFormat(p.total_planeado)).toFixed(0),
            'TOTAL EJECUTADO': (numberFormat(p.total_ejecutado)).toFixed(0),
            'TOTAL HORAS PLAN': 0,
            'TOTAL PERSONAL PLAN': 0,
         };
         dias.forEach(dia => {
            if (rendimiento) {
               reg['TOTAL HORAS PLAN'] += p[dia.toLowerCase() + "_plan"] / rendimiento;
            }
            reg[dia.toUpperCase() + " PLANEADO"] = p[dia.toLowerCase() + "_plan"];
            reg[dia.toUpperCase() + " HORAS"] = rendimiento ? +(p[dia.toLowerCase() + "_plan"] / rendimiento).toFixed(1) : '❌ SIN RENDIMIENTO';
            reg[dia.toUpperCase() + " PERSONAL"] = rendimiento ? +(p[dia.toLowerCase() + "_plan"] / rendimiento / 8).toFixed(1) : '❌ SIN RENDIMIENTO';
            reg[dia.toUpperCase() + " EJECUTADO"] = p[dia.toLowerCase() + "_ejecutado"];
         });
         reg['TOTAL PERSONAL PLAN'] = +(reg['TOTAL HORAS PLAN'] / 8).toFixed(1);
         reg['TOTAL HORAS PLAN'] = +(reg['TOTAL HORAS PLAN']).toFixed(1);
         dt.push(reg);
      }
      generarExcel(dt, 'PROGRAMA_SIEMBRA_POR_DIA_' + args.semana)
   }

   const actualizarSemanaEjecucion = (i, newData) => {
      {
         let pl = [...planes];
         pl[i].semana_ejecucion = newData.semana;
         pl[i].fecha_semana_ejecucion = newData.fecha;
         setPlanes(pl);
      }
   }

   const definirRendimientoButton = (registro) => {
      return (
         <button
            type="button"
            className="p-0 mt-1 scale-025 text-bold btn btn-sm round-xxl text-dark text-center btn-warning m-0 bw-150"
            title="Definir rendimiento"
            onClick={() => { seteditorRendimiento(registro) }}
         >
            Definir rendimiento
         </button>
      )
   }

   const cerrarEditorRendimientos = (value) => {
      if (value) {
         setPlanes(value.planes);
         setFlores(value.flores);
         settotales(value.totales);
      }
      seteditorRendimiento(false);
   }

   /**
    * De acuerdo al estado del registro se devuelve un input bloqueado, dsbloqueado o un mensje de error
    */
   const inputPlaenacion = (registro, index, dia) => {
      let htmlElement = undefined;
      if (registro.semilla_disponible === 'NO') {
         htmlElement = (<div className='w-100 text-center'>❌ Sin semilla disponible</div>);
      } else if (registro.unidad_hora || !registro.unidad_hora && dia.toLowerCase() !== 'lunes') {

         htmlElement = (<>
            <CantidadSiembraSemanal
               plan={registro}
               value={registro[`${dia.toLowerCase()}_plan`]}
               dia={dia.toLowerCase()}
               tipo="plan"
               index={index}
               disabled={[null, undefined, '', 0].includes(registro.unidad_hora) || registro.semilla_disponible === 'NO'}
               fn={actualizarTotales} />
            <div className='m-0 p-0 contenedor text-s border-start' style={{ width: '55px' }}>
               {registro.unidad_hora ? Math.ceil(registro[`${dia.toLowerCase()}_plan`] / registro.unidad_hora) : '-'}
            </div>
            <div className='m-0 p-0 contenedor text-s border-start' style={{ width: '40px' }}>
               {registro.unidad_hora ? +(registro[`${dia.toLowerCase()}_plan`] / registro.unidad_hora / 8).toFixed(1) : '-'}
            </div>
         </>);
      } else if (!registro.unidad_hora && dia.toLowerCase() === 'lunes') {
         htmlElement = definirRendimientoButton(registro);
      }


      return (
         <div className='w-100 pt-1 pb-0 m-0'>
            <div className='row justify-content-evenly text-m p-0 m-0 w-100'>
               {htmlElement}
            </div>
         </div>);

   }

   return (
      <div className="w-full p-1 right-0 dosis" >
         <div className="bg-white border rounded shadow-xl">
            <div className="border-b rounded-t p-2 bg-orange-900">
               <p className="font-bold uppercase text-white h4">Planificación de siembra por día de la semana <span className="text-s text-300 text-white ms-3">Defina cómo se distribuirá el plan trabajo entre los 6 días en cada semana</span></p>
            </div>
            <div className='row justify-content-evenly w-100 p-0 m-0'>

               <div className="bw-150 mb-2 mt-1">
                  <select className='form-select' name="semana" value={args.semana}
                     onChange={ajustarArgs}>
                     <option value=''>Semana</option>
                     {
                        semanas.map((semana) => {
                           return (
                              <option value={semana.semana} key={semana.semana}>{semana.semana}</option>
                           )
                        })
                     }
                  </select>
               </div>

               <div className="mb-2 mt-1 bw-150" >
                  <select className='form-select' name="flor" value={args.flor}
                     onChange={ajustarArgs}>
                     <option value=''>Flor tipo</option>
                     {
                        tipos.flores.map((flor) => {
                           return (
                              <option value={flor.flor} key={'flor' + flor.flor}>{flor.flor}</option>
                           )
                        })
                     }
                  </select>
               </div>

               <div className="mb-2 mt-1 bw-150" >
                  <select className='form-select' name="variedad" value={args.variedad}
                     onChange={ajustarArgs}>
                     <option value=''>Variedad</option>
                     {
                        tipos.variedades.map((vr) => {
                           return (
                              <option value={vr.variedad} key={'variedad' + vr.variedad}>{vr.variedad}</option>
                           )
                        })
                     }
                  </select>
               </div>

               <div className="mb-2 mt-1 bw-150">
                  <select className='form-select' name="color" value={args.color}
                     onChange={ajustarArgs}>
                     <option value=''>Color</option>
                     {
                        tipos.colores.map((color) => {
                           return (
                              <option value={color.color} key={'color' + color.color}>{color.color}</option>
                           )
                        })
                     }
                  </select>
               </div>
               {totales_keys.map((dt, i) => {
                  let pl = dt.key + "plantas", ch = dt.key + "charolas";
                  return (
                     <div key={"totales" + i} className={`m-1 col-auto text-s p-0 contenedor`} >
                        <div className={`w-100 p-1 pe-2 ps-2  ${dt.color} border round-s text-center`}>
                           <div className='row justify-content-evenly w-100 m-0 p-0'>
                              <div className="w-100 m-0 p-0">{dt.name}
                                 <span className="text-s ms-2 text-bold"> {totales[pl]} pl <span className="text-dark ms-1 me-1 text-bold">-</span>{totales[ch]} ch</span>
                              </div>
                           </div>
                        </div>
                     </div>
                  )
               })}

               <div className="m-0 contenedor col-auto">
                  <button className='btn btn-sm scale-05 m-0 bw-100 btn-success bg-green3 shadow text-bold round-xl' onClick={descargarExcel}>Excel</button>
               </div>
               <div className="m-0 contenedor col-auto" >
                  <button className='btn btn-sm scale-05 m-0 bw-100 btn-danger bg-red2 border border-dark border-2 shadow text-bold round-xxl'
                     onClick={() => { if (!pdf && planes.length > 0) setpdf(true); }}>PDF</button>
               </div>
            </div>
            {planes.length == 0 && flores.length == 0 && <div className='col-sm-12 h4 text-center p-3'>Para empezar seleccione una semana (En la esquina superior izquierda) para listar los resultados</div>}
            {
               planes.length > 0 &&
               <div className=" mt-0 pt-0" style={{ height: Verifiers.maxHeight(screen, 700, 1200, 81, .8), width: '100%', overflow: 'auto' }}>
                  <table className="table table-responsive table-sm table-bordered  table-hover mb-3" style={{ width: '100%' }}>
                     <thead className="">
                        <tr className=" text-center">
                           <th className="text-center text-s border nowrap">Historial</th>
                           <th className="text-center text-m border nowrap">Flor variedad color</th>
                           <th className="text-center text-s border nowrap bw-100">S. ejecución</th>
                           <th className="text-center text-s border nowrap" style={{ minWidth: "75px", maxWidth: "75px" }} >S. cosecha</th>
                           <th className="text-center text-m border nowrap m-0 p-0 ps-2 pe-2" style={{ width: "130px", maxWidth: "130px" }}>
                              <div className='w-100 m-0 p-0 text-s text-center'>Plan siembra</div>
                              <div className='w-100 m-0 p-0 text-xs text-center'>
                                 Plantas{divisor()}Charolas{divisor()}Hrs
                              </div>
                           </th>

                           <th className="text-center text-xs border text-bold nowrap">
                              <div className='w-100 m-0 p-0 text-s'>Sumatoria (charolas)</div>
                              Plan{divisor()}Hrs{divisor()}Pers

                           </th>
                           {dias.map((d, i) => <th key={d + i} className="text-center text-m border border-orange-900 px-2 py-1">
                              <div className='w-100 m-0 p-0'>{d}</div>
                              <div className='w-100 m-0 p-0 text-xs text-center'>
                                 Planeado{divisor()}Horas{divisor()}Personal
                              </div>
                           </th>)}
                        </tr>
                     </thead>
                     <tbody>
                        {planes.map((p, i) => {

                           return (
                              <tr key={i + ' planssss'} className="border">
                                 <td className="text-center">
                                    <button
                                       type="button"
                                       className={"p-0 ps-1 pe-1 scale-025 btn btn-sm round-xs text-white " + (p.history > 0 ? "" : "disabled")}
                                       style={{ backgroundColor: '#9c4221' }} title="Historial de este registro" onClick={() => setShowHistory(showHistory ? false : p.id)}
                                    >
                                       <i className="fa fa-history" aria-hidden="true"></i>
                                    </button>
                                 </td>
                                 <td className={` border text-left text-m nowrap ${diferencia(p) !== 0 ? "rosa-retrasado" : "bg-white"}`} >
                                    {p.flor} {p.variedad} {p.color}
                                 </td>
                                 <td className="border text-left text-center text-bold text-xs nowrap" style={{ width: "110px" }}>
                                    <InputSemanaEjecucion
                                       data={p}
                                       update={(newData) => actualizarSemanaEjecucion(i, newData)} />
                                 </td>
                                 <td className="border text-left text-s text-center " style={{ width: "70px", maxWidth: "70px" }}>{p.semanaCosecha}</td>
                                 <td className=" text-300 bw-200 text-s text-center" >
                                    {Math.round(numberFormat(p.plantas, '-'))}
                                    {divisor()}{Math.round(numberFormat(p.charolas))}
                                    {divisor()}{p.unidad_hora ? Math.ceil(p.charolas / p.unidad_hora) : '-'}
                                 </td>

                                 <td className='text-center text-400'
                                    style={{ backgroundColor: p.total_planeado >= Math.round(numberFormat(p.charolas)) ? "rgba(168, 255, 242,.4)" : "rgba(168, 255, 189,0)" }}
                                 >
                                    {(numberFormat(p.total_planeado)).toFixed(0)}
                                    {divisor()}{p.unidad_hora ? Math.ceil(p.total_planeado / p.unidad_hora) : '-'}
                                    {divisor()}{p.unidad_hora ? Math.ceil(p.total_planeado / p.unidad_hora / 8) : '-'}
                                 </td>
                                 {
                                    dias.map((dia, j) => {
                                       return (
                                          <td className="border text-center text-m p-0 m-0" key={i + 'dia sect' + j} style={{ minWidth: '190px', maxWidth: '190px' }}>
                                             {inputPlaenacion(p, i, dia)}
                                          </td>
                                       )
                                    })
                                 }
                              </tr>
                           );
                        })}
                        {renglonSumatoriaDeColumnas()}
                     </tbody>
                  </table>
               </div>
            }
         </div>


         {loader && <MyLoader />}


         {showHistory && <HistorialEjecucionesSiembra close={() => setShowHistory(false)} planID={showHistory} />}

         {pdf && <div className='vw-100 vh-100 m-0 p-0 bg-white3 blur-xl' style={{ position: "fixed", zIndex: 99, top: 0, left: 0, overflow: 'auto' }}>
            <div className='row justify-content-evenly p-0 m-0 w-100'>
               <EjecucionSiembraPDF data={planes} loader={updateLoader} close={() => { setpdf(false) }} />
            </div>
         </div>}
         {editorRendimiento && <EditorRendimientoSiembra data={editorRendimiento} close={cerrarEditorRendimientos} args={JSON.parse(JSON.stringify(args))} />}
      </div>
   );
};

export default EjecucionSiembra;
